!(function () {
  "use strict";

  customElements.get("image-accordions") ||
    customElements.define(
      "image-accordions",
      class extends HTMLElement {
        constructor() {
          super();
          this.container = this.parentNode;
          this.controller = new AbortController();
          this.accordionExpandEvent = (t) => this.accordionExpand(t);
          this.accordionFocusEvent = (t) => this.accordionFocus(t);
        }

        connectedCallback() {
          this.imageAccordionsItems = this.querySelectorAll("[data-accordion-item]");
          this.buttons = this.querySelectorAll("[data-accordion-button]");

          this.triggerLoadingAnimation();

          this.imageAccordionsItems.forEach((item) => {
            item.addEventListener("mouseenter", () => this.accordionExpand(item), {
              signal: this.controller.signal,
            });
          });

          this.buttons.forEach((btn) => {
            btn.addEventListener("focusin", () => this.accordionFocus(btn), {
              signal: this.controller.signal,
            });
          });

          this.imageAccordionsItems.forEach((item) => {
            item.addEventListener("click", () => this.accordionExpand(item), {
              signal: this.controller.signal,
            });
          });
        }

        disconnectedCallback() {
          this.controller.abort();
        }

        triggerLoadingAnimation() {
          const animationsDisabled =
            document.body.dataset.animations === "false" ||
            window.matchMedia("(prefers-reduced-motion: reduce)").matches;

          if (animationsDisabled) return;

          const onAnimationEnd = (e) => {
            if (e.animationName === "expandAccordion") {
              this.accordionExpand(this.imageAccordionsItems[0]);
              this.container.classList.remove("to-animate");
              this.container.classList.remove("is-animating");
              this.container.removeEventListener("animationend", onAnimationEnd);
            }
          };

          const onTransitionEnd = (e) => {
            requestAnimationFrame(() => {
              if (e.target === this.container) {
                this.container.classList.add("is-animating");
                this.container.removeEventListener("transitionend", onTransitionEnd);
              }
            });
          };

          this.container.addEventListener("transitionend", onTransitionEnd, {
            signal: this.controller.signal,
          });

          this.container.addEventListener("animationend", onAnimationEnd, {
            signal: this.controller.signal,
          });
        }

        accordionExpand(item) {
          if (item.classList.contains("is-active")) return;

          this.imageAccordionsItems.forEach((i) => i.classList.remove("is-active"));
          item.classList.add("is-active");
        }

        accordionFocus(btn) {
          btn.closest("[data-accordion-item]")?.dispatchEvent(new Event("mouseenter"));
        }
      }
    );
})();